// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".loading-overlay{position:absolute;top:0;left:0;width:100%;height:100%;background:#fff;opacity:.8;z-index:5}.loading-overlay__icon{display:block;position:absolute;top:50%;left:50%;margin-top:-16px;margin-left:-16px;width:32px;height:32px;fill:#c3c4be;animation:spinner 1s infinite steps(8)}.loading-overlay__icon.loading-overlay__icon--small{margin-top:-8px;margin-left:-8px;width:16px;height:16px}.loading-overlay__icon svg{display:block;width:100%;height:100%}", ""]);
// Exports
module.exports = exports;
